/**
 * Shared primitives for Select and MultiSelect.
 * Keeps both components in sync without duplication.
 */
import { ChevronDown } from "lucide-react";

// ── Class strings ──────────────────────────────────────────────────────────────

/** Shared trigger button base classes (padding/sizing differ per component). */
export const TRIGGER_SHARED_CLS =
  "photon-field w-full text-[13px] border-[0.5px] rounded-[10px] bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-focus-primary/50 transition-colors";

/** Border colour — red when in error state, grey otherwise. */
export const triggerBorderCls = (error) =>
  error ? "photon-field-invalid border-edge-red-500" : "border-edge-hex-d8d8d8 dark:border-edge-hex-aaaaaa50";

/** Dropdown list container. */
export const DROPDOWN_LIST_CLS =
  "absolute z-50 w-full mt-1 bg-fill-white dark:bg-fill-deep-surface border border-edge-gray-200 dark:border-edge-gray-600 rounded-lg shadow-lg max-h-60 overflow-auto";

/** Top border separator between rows (skipped for the first row). */
export const rowSepCls = (i) =>
  i > 0 ? "border-t border-edge-gray-100 dark:border-edge-gray-700" : "";

/** Hover + selected background for a row. */
export const rowBgCls = (selected) =>
  selected
    ? "bg-fill-primary/10"
    : "hover:bg-fill-gray-50 dark:hover:bg-fill-dialog-surface";

// ── Shared sub-components ──────────────────────────────────────────────────────

/** Animated chevron that flips when the dropdown is open. */
export const DropdownChevron = ({ open }) => (
  <ChevronDown
    className={`w-4 h-4 text-ink-gray-400 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
  />
);

/** Grey description line beneath an option label. */
export const OptionDescription = ({ text }) =>
  text ? (
    <div className="text-xs text-ink-gray-500 dark:text-ink-gray-400 mt-0.5">{text}</div>
  ) : null;
